<template>
  <div class="bg-gray-50 rounded-lg p-6 sticky top-24 min-h-600">
    <div class="p-4 border-b border-gray-200 flex items-center space-x-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-gray-400"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
          clip-rule="evenodd"
        />
      </svg>
      <span class="text-gray-700 font-medium uppercase"
        >Product Categories</span
      >
    </div>

    <div class="divide-y divide-gray-100">
      <div v-for="item in categories" :key="item.category">
        <div
          @click="toggleCategory(item)"
          class="px-4 py-1 rounded-sm flex items-center justify-between cursor-pointer transition-all hover:bg-[#FF4D6A]"
          :class="{
            'bg-[#FF4D6A] text-white': activeCategory === item.category
          }"
        >
          <div class="flex items-center space-x-2">
            <span
              class="font-medium"
              :class="{ 'text-white': activeCategory === item.category }"
            >
              {{ item.category }}
            </span>
          </div>
          <svg
            v-if="item.sublist"
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 text-gray-400 transition-all"
            :class="{
              'transform rotate-90': openCategories.includes(item.category)
            }"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clip-rule="evenodd"
            />
          </svg>
        </div>

        <div
          v-if="item.sublist"
          class="sublist bg-gray-50 ml-5"
          :class="{ open: openCategories.includes(item.category) }"
        >
          <div
            v-for="(subitem, subIndex) in item.sublist"
            :key="subIndex"
            @click="selectSubItem(item, subitem)"
            class="px-3 py-1 text-sm transition-all"
            :class="{
              'font-bold': activeSubItem === subitem
            }"
          >
            <span class="cursor-pointer hover:font-bold">{{ subitem }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCategories',
  components: {
    // CategoryItem
  },
  props: {
    activeCategorie: {
      type: String,
      default: ''
    },
    categories: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    activeCategorie: {
      handler(newCategorie, oldCategorie) {
        this.processCategories(this.categories)
      }
    },
    categories: {
      handler(newArr, oldArr) {
        this.processCategories(newArr)
      }
    }
  },
  data() {
    return {
      maxPrice: 10,
      // categories: [],
      openCategories: [],
      isExpanded: true,
      activeCategory: '',
      activeSubItem: ''
    }
  },
  created() {
    // this.loadCategories()
  },
  computed: {
    selectedCategory() {
      return (
        this.categories.find((item) => item.category === this.activeCategory) ||
        null
      )
    }
  },
  methods: {
    processCategories(arr) {
      // console.log(this.activeCategorie)
      const firstWithSublist = this.categories.find((item) => item.sublist)
      if (firstWithSublist) {
        this.openCategories.push(firstWithSublist.category)
        // this.activeSubItem = this.categories[0].sublist[0]
        // this.$emit(
        //   'category-click',
        //   this.categories[0],
        //   this.categories[0].sublist[0]
        // )
      }
      // this.$bus.$emit(
      //   'category-selected',
      //   this.categories[0],
      //   this.categories[0].sublist[0]
      // )
      // 设置默认选中第一个
      if (!this.activeCategorie || this.activeCategorie === 'Keychain') {
        this.activeCategory = this.categories[0].category
        if (firstWithSublist) {
          // this.openCategories.push(firstWithSublist.category)
          this.activeSubItem = this.categories[0].sublist[0]
          this.$emit(
            'category-click',
            this.categories[0],
            this.categories[0].sublist[0]
          )
        }
        this.$bus.$emit(
          'category-selected',
          this.categories[0],
          this.categories[0].sublist[0]
        )
      } else {
        this.activeCategory = this.activeCategorie
        for (let i = 0; i < this.categories.length; i++) {
          if (this.activeCategorie === this.categories[i].category) {
            this.activeSubItem = ''
            this.$bus.$emit(
              'category-selected',
              this.categories[i],
              this.categories[i].category.sublist
                ? this.categories[i].sublist[0]
                : null
            )
            this.$emit('category-click', this.categories[i])
            break
          }
        }
      }
    },
    // 获取到所有类目
    // loadCategories() {
    //   this.$api.sysApi.getCategories().then((res) => {
    //     this.categories = res.data
    //     const firstWithSublist = this.categories.find((item) => item.sublist)
    //     if (firstWithSublist) {
    //       this.openCategories.push(firstWithSublist.category)
    //       console.log(JSON.stringify(firstWithSublist))
    //       this.activeSubItem = res.data[0].sublist[0]
    //       this.$bus.$emit(
    //         'category-selected',
    //         res.data[0],
    //         res.data[0].sublist[0]
    //       )
    //     }
    //     // 设置默认选中第一个
    //     this.activeCategory = res.data[0].category
    //   })
    // },
    // 选中主类目
    toggleCategory(item) {
      this.activeCategory = item.category
      this.activeSubItem = ''
      if (item.sublist) {
        const index = this.openCategories.indexOf(item.category)
        if (index > -1) {
          this.openCategories.splice(index, 1)
        } else {
          this.openCategories.push(item.category)
        }
      } else {
        // 没有子节点，直接获取说明、图片数据，向上传递函数
        this.$bus.$emit('category-selected', item, null)

        this.$emit('category-click', item)
      }
    },
    // 选中子节点
    selectSubItem(item, subitem) {
      this.activeCategory = item.category
      this.activeSubItem = subitem
      // console.log(this.activeSubItem)
      if (!this.openCategories.includes(item.category)) {
        this.openCategories.push(item.category)
      }
      // 获取说明、图片数据，向上传递函数
      this.$emit('category-click', item, subitem)
      this.$bus.$emit('category-selected', item, subitem)
    },
    getCategoryCount(category) {
      if (category === 'Keychain') {
        return this.products.length
      }
      return this.products.filter((product) => product.category === category)
        .length
    },
    selectCategory(category) {
      // this.$emit('category-selected', category)
    },
    updatePriceFilter(event) {
      this.maxPrice = parseInt(event.target.value)
      this.$emit('price-filter-updated', this.maxPrice)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.transition-all {
  transition: all 0.25s ease-in-out;
}
.sublist {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
}
.sublist.open {
  max-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/page/products/ProductCategories.vue